import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';

function Gallery({info}) {
    const navigate = useNavigate();
    const params = useParams();
    const slug = params['*'];

    const handleCategoryClick = (path) => {
        navigate(`/${slug}/${path}`);
    };

    const content = info.body || info.extra || '';

    return (
        <div className="justify">
            <div className="justify">
                {typeof content === "string" ? parse(content) : null}
            </div>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "12px",
                    width: "100%"
                }}
            >
                {info.children.map((page, idx) => (
                    <div key={idx} className="justify">
                        <div
                            onClick={() => handleCategoryClick(page.slug)}
                            style={{
                                background: `url('${page.preview}') center center / cover no-repeat`,
                                height: "300px",
                                width: "100%",
                                borderRadius: "10px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                cursor: "pointer",
                                position: "relative",
                            }}
                            className="category-block"
                        >
                            <div className="image-info">
                                <span className="imageTitle">{page.title}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {slug.split('/').length > 1 &&
                <button
                    className="btn-back"
                    onClick={() => navigate(`/${slug.split('/').slice(0, -1).join('/')}`)}
                >
                    Go Back
                </button>
            }
        </div>
    );
}

export default Gallery;